import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerSeparationListItem = (props) => {
    const { visualizerSeparationFactor, updateVisualizerSettings, maxSeperationFactor } = props;
    
    const onLayerSeparationChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ seperationFactor: value });
    };
    
    return (
        <SliderListItem
            title='Separation'
            value={visualizerSeparationFactor}
            displayMultiplier={100 / maxSeperationFactor}
            min={0}
            max={100}
            step={1}
            onValueChange={onLayerSeparationChange}
            toolTip='The separation distance between wave layers. Behaves differently depending on the "LAYERS" setting'
        />
    );
};

const mapStateToProps = (state) => {
    const { seperationFactor: visualizerSeparationFactor } = state.createPreview.present.videoSettings.visualizer;
    const { maxSeperationFactor } = state.create.maxValues;

    return { 
        visualizerSeparationFactor,
        maxSeperationFactor
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSeparationListItem);